import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOptionKey: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconOptionKey"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 9H9.38184L13.3818 17H17V15H14.6182L10.6182 7H7V9ZM13.5 7V9H17V7H13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOptionKey;
